import { config as configCategoryRoute } from '~/config/router/categories';

export default function (path) {
    return configCategoryRoute.seasonPrefixes.find(seasonPrefix => path.indexOf(seasonPrefix) !== -1);
}
